export const FOLDERS_QUERY_LIMIT = 10000;
export const VIDEOS_QUERY_LIMIT = 50;

export const VIEW_TYPE_GRID = 'grid';
export const VIEW_TYPE_LIST = 'list';
export const VIEW_MEDIA_VIDEOS = 'videos';
export const VIEW_MEDIA_SCREENSHOTS = 'screenshots';

export const RECENT_FILTER = 'Recent';
export const LIBRARY_FILTER = 'Library';
export const ALL_FILTER = 'All';
export const VIDEOS_FILTER = 'Videos';
export const FOLDERS_FILTER = 'Folders';
export const MY_ARCHIVE_FILTER = 'My Archive';
export const TEAM_ARCHIVE_FILTER = 'Team Archive';

export const ALL_CONTENT_FILTERS = [
  RECENT_FILTER,
  LIBRARY_FILTER,
  ALL_FILTER,
  VIDEOS_FILTER,
  FOLDERS_FILTER,
  MY_ARCHIVE_FILTER,
  TEAM_ARCHIVE_FILTER,
];

export const FOLDER = 'folder';
export const VIDEO = 'video';
export const SCREENSHOT = 'screenshot';

export const ALL_CARD_TYPES = [FOLDER, VIDEO, SCREENSHOT];
